export const TOUR_IDS = {
  PLATFORM_OVERVIEW: 'platform-overview',
  SETUP_MASTER_DATA: 'setup-master-data',
  SETUP_FAMILIES: 'setup-families',
  SETUP_COMPARED_ATTRIBUTES: 'setup-compared-attributes',
  SETUP_COMPLIANCE_RULES: 'setup-compliance-rules',
  PRODUCTS_CATALOG: 'products-catalog',
  DISTRIBUTORS: 'distributors',
  TERM_WATCHES: 'term-watches',
  SCHEDULE_CHECKS: 'schedule-checks',
  MONITOR_JOBS: 'monitor-jobs',
  FINDINGS_REPORTS: 'findings-reports',
} as const

export type TourId = (typeof TOUR_IDS)[keyof typeof TOUR_IDS]

export const TOUR_STORAGE_PREFIX = 'mim-tour-complete:'
export const TOUR_SESSION_KEY = 'mim-tour-session'
